import { states } from "../../../../constants/data";
import Styles from "../editScreenStyles.module.css";
import { yesNo, yesNoUnsure } from "../../../../constants/options";
import { textToBoolean } from "../../../../utilities/dataUtilities";

function OtherPropertyEdit({
  fields,
  utilities,
  updateClicked,
  cancelClicked
}) {

  const {
    createToggleInput,
    createEditScreenInput,
    createCustomLabelSelect,
    createCustomLabelTextArea
  } = utilities;

  return (
    <div>
      <div className={Styles.title}>Additional Damaged Property</div>
      <div className={Styles.column}>
        {createToggleInput(fields.damageToProperty, "100%", yesNoUnsure, true)}
        {textToBoolean(fields.damageToProperty.value) && (
          <>
           {createToggleInput(fields.whoOwnsProperty, "100%", yesNo, true)}
            <hr className={Styles.hr} />
            {fields.whoOwnsProperty.value && (
              <>
                <div className={Styles.row}>
                  {createEditScreenInput(fields.propertyOwnerFirstName, "100%", Styles.input, Styles.label, {altLabel: "First Name"})}
                  {createEditScreenInput(fields.propertyOwnerLastName, "100%", Styles.input, Styles.label, {altLabel: "Last Name"})}
                </div>
                <div className={Styles.row}>
                  {createEditScreenInput(fields.propertyOwnerAddress, "100%", Styles.input, Styles.label)}
                  {createEditScreenInput(fields.propertyOwnerCity, "100%", Styles.input, Styles.label)}
                </div>
                <div className={Styles.row}>
                  {createCustomLabelSelect(fields.propertyOwnerState, states, Styles.select, Styles.label, {placeholder: "Select a state"})}
                  {createEditScreenInput(fields.propertyOwnerZipcode, "100%", Styles.input, Styles.label)}
                </div>
                <div className={Styles.row}>
                  {createEditScreenInput(fields.propertyOwnerCounty, "100%", Styles.input, Styles.label)}
                  {createEditScreenInput(fields.propertyOwnerPhone, "100%", Styles.input, Styles.label, { type: "tel" })}
                </div>
                <div className={Styles.row}>
                  {createEditScreenInput(fields.propertyOwnerEstimateOfDamage, "100%", Styles.input, Styles.label, { placeholder: "$"})}
                </div>

                <div
                  className={Styles.column}
                  style={{ alignItems: "flex-start" }}
                >
                  {createCustomLabelTextArea(fields.propertyOwnerDescribeProperty, "100%", Styles.textarea, Styles.blockLabel)}
                </div>

                <div
                  className={Styles.column}
                  style={{ alignItems: "flex-start" }}
                >
                  {createCustomLabelTextArea(fields.propertyOwnerDamageProperty, "100%", Styles.textarea, Styles.blockLabel)}
                </div>
              </>
            )}
          </>
        )}
        <div className={Styles.buttons}>
          <button
            type="button"
            className={Styles.button}
            onClick={cancelClicked}
          >
            Cancel
          </button>
          <button
            type="button"
            className={Styles.button}
            onClick={updateClicked}
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
}

export default OtherPropertyEdit;
